import { computed, makeObservable } from 'mobx';

import { getLogsStorageKey, LogsMode } from '@/features/logsMode';
import { ListModel } from '@/models/ListModel';
import { YandexUser } from '@/types/yandex';

export class FavoriteUsersModel {
  private readonly _favoriteUsers = new ListModel<YandexUser, string>();
  private readonly _storageKey: string;

  constructor(mode: LogsMode = LogsMode.legacy) {
    this._storageKey = getLogsStorageKey({ key: 'favoriteUsers', mode });

    makeObservable(this, {
      favoriteUsers: computed,
    });

    this.loadFromStorage();
  }

  get favoriteUsers() {
    return this._favoriteUsers.items;
  }

  isFavorite = (id: string): boolean => {
    return this.favoriteUsers.some((user) => user.uid === id);
  };

  toggleFavoriteUser = (user: YandexUser) => {
    if (this.isFavorite(user.uid)) {
      this.removeFavoriteUser(user);
    } else {
      this.addFavoriteUser(user);
    }
  };

  private addFavoriteUser = (user: YandexUser) => {
    this._favoriteUsers.addEntity({ entity: user, key: user.uid });

    this.saveToStorage();
  };

  private removeFavoriteUser = (user: YandexUser) => {
    this._favoriteUsers.removeEntity(user.uid);

    this.saveToStorage();
  };

  private saveToStorage() {
    localStorage.setItem(this._storageKey, JSON.stringify(this._favoriteUsers.items));
  }

  private loadFromStorage() {
    const favoriteUsers = localStorage.getItem(this._storageKey);

    if (favoriteUsers) {
      const users: YandexUser[] = JSON.parse(favoriteUsers);
      this._favoriteUsers.fillByRawData(users, (user) => ({ entity: user, key: user.uid }), true);
    }
  }
}
